export const MODAL_WIDTH = 600;
export const RIGHT_PANEL_WIDTH = 440;
